import { Tooltip, useToast } from "@chakra-ui/react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { useEffect, useMemo, useState } from "react";
import Button from "../Button/Button";
import { TextBox } from "../TextBox";
import CSS from "./styles.module.css";

const DocPage = ({ children, isActive, lang }) => {
	const toast = useToast();

	const [sideBar, setSideBar] = useState(false);
	const [sideBarExist, setSideBarExist] = useState(true);

	const handleCopy = async () => {
		try {
			var originalText,
				htmlText,
				blobHtml,
				blobText,
				data = "";

			if (document.querySelector(".ck-content")) {
				originalText = document.querySelector(".ck-content").innerText;
				htmlText = document.querySelector(".ck-content").innerHTML;
				blobHtml = new Blob([htmlText], { type: "text/html" });
				blobText = new Blob([originalText], { type: "text/plain" });
				data = [
					new ClipboardItem({ "text/plain": blobText, "text/html": blobHtml }),
				];

				navigator.clipboard.write(data);

				toast({
					description: "Copied to Clipboard",
					status: "success",
					duration: 5000,
					isClosable: true,
					position: "bottom-left",
				});
			}
		} catch (error) {
			console.log(error);
		}
	};

	// This regular expression will match the placeholders
	const regex = /\[.*?\]/g;

	// This will hold the matches
	const placeholders = [...new Set(children.match(regex))] || [];

	const clPlaceholders = placeholders.map((item) => item.slice(1, -1));

	// State for the textboxes and the HTML content
	const [values, setValues] = useState([]);
	const [htmlContent, setHtmlContent] = useState();

	const newValues = useMemo(() => {
		return [...values];
	}, [values]);

	useEffect(() => {
		if (children === "") {
			setTimeout(() => {
				setSideBar(false);
			}, 300);
			setTimeout(() => {
				setSideBarExist(false);
			}, 600);
			setHtmlContent("");
		} else if (children !== "") {
			setHtmlContent(children);
			setValues(placeholders);
			setSideBarExist(true);
			setTimeout(() => {
				setSideBar(true);
			}, 700);
		}
	}, [children]);

	useEffect(() => {
		const timeout = setTimeout(() => {
			setValues(newValues);
		}, 600);
		return () => {
			clearTimeout(timeout);
		};
	}, [values, newValues]);

	// Handle input change
	const handleChange = (e, index) => {
		if (e.target.value !== "") {
			newValues[index] = e.target.value;
			setValues(newValues);
			const newData = htmlContent
				.split(placeholders[index])
				.join(e.target.value);
			setHtmlContent(newData);
			placeholders[index] = e.target.value;

			const parentDiv = e.target.parentNode;
			parentDiv.classList.add(CSS.HideTxtBox);
			setTimeout(() => {
				parentDiv.classList.add(CSS.hidden);
			}, 600);
			if (placeholders.length - 1 === index) {
				setTimeout(() => {
					setSideBar(false);
				}, 350);
				setTimeout(() => {
					setSideBarExist(false);
				}, 600);
			}
		}
	};

	return (
		<div
			className={`${CSS.Container} ${isActive ? CSS.ContainerActive : ""} ${
				sideBar ? CSS.ContainerSB : ""
			}`}
		>
			<CKEditor
				editor={ClassicEditor}
				data={htmlContent}
				config={{
					toolbar: [
						"heading",
						"|",
						"bold",
						"italic",
						"blockQuote",
						"|",
						"bulletedList",
						"numberedList",
						"|",
						"undo",
						"redo",
					],
				}}
				onReady={(editor) => {
					// You can store the "editor" and use when it is needed.
					console.log("Editor is ready to use!", editor);
				}}
				onChange={(event, editor) => {
					const data = editor.getData();
					console.log({ event, editor, data });
				}}
				onBlur={(event, editor) => {
					console.log("Blur.", editor);
				}}
				onFocus={(event, editor) => {
					console.log("Focus.", editor);
				}}
			/>

			<div
				className={`${CSS.Actionables} ${"HiddenContent"} ${
					sideBar ? CSS.sbActiveBtns : ""
				}`}
				id="actionables"
				contentEditable={false}
			>
				<div className={`${CSS.ceButtons}`}>
					<Tooltip hasArrow label="Copy this email">
						<div>
							<Button
								leftIcon="content_copy"
								onClick={handleCopy}
								className={`${CSS.CopyButton}`}
							/>
						</div>
					</Tooltip>
					{sideBarExist && (
						<Tooltip
							hasArrow
							label={sideBar ? "Close Sidebar" : "Open Sidebar"}
						>
							<div>
								<Button
									leftIcon="arrow_back_ios_new"
									onClick={() => setSideBar(!sideBar)}
									className={`${CSS.CopyButton} ${
										sideBar ? CSS.sbActive : ""
									} `}
								/>
							</div>
						</Tooltip>
					)}
				</div>
			</div>

			{sideBarExist && (
				<div className={`${CSS.SideBar} ${sideBar ? CSS.SideBarActive : ""}`}>
					<div className={CSS.Header}>Smart inputs</div>
					<div className={CSS.TBContainer}>
						{values &&
							values.map((value, index) => (
								<TextBox
									key={index}
									placeholder={clPlaceholders[index]} // Set the placeholder text
									onBlur={(e) => handleChange(e, index)}
									onKeyDown={(e) => {
										if (e.keyCode === 13) {
											handleChange(e, index);
											console.log(e.keyCode);
										}
									}}
									wide
								/>
							))}
					</div>
				</div>
			)}
		</div>
	);
};

export default DocPage;
